const INTERNAL_ORIGIN = 'https://ludoking.internal';
const hasControlCharacters = value => Array.from(value).some(character => {
    const code = character.charCodeAt(0);
    return code <= 31 || code === 127;
});
const ENCODED_BACKSLASH = /%5c/i;

/**
 * Return a normalized same-origin path, or null for external/malformed input.
 * This is intentionally strict because React Router navigation must never
 * receive user-controlled absolute, protocol-relative, or backslash URLs.
 */
export const getSafeInternalPath = value => {
    if (typeof value !== 'string') return null;
    const raw = value.trim();
    if (!raw || hasControlCharacters(raw) || ENCODED_BACKSLASH.test(raw)) return null;

    let decoded;
    try {
        decoded = decodeURIComponent(raw);
    } catch (_) {
        return null;
    }

    if (
        !decoded.startsWith('/')
        || decoded.startsWith('//')
        || decoded.includes('\\')
        || hasControlCharacters(decoded)
    ) {
        return null;
    }

    try {
        const url = new URL(decoded, INTERNAL_ORIGIN);
        if (url.origin !== INTERNAL_ORIGIN) return null;
        return `${url.pathname}${url.search}${url.hash}`;
    } catch (_) {
        return null;
    }
};
